module.exports = __webpack_public_path__ + "img/balao-de-fala.beb58799.png";